import { Link } from 'react-router-dom';
import { Sparkles, AlertTriangle, ArrowUpRight } from 'lucide-react';
import { useLanguage } from '../../features/language/useLanguage';
import { useSubscription } from '../../hooks/useSubscription';

export function SubscriptionBanner() {
  const { isFree, isPaid, daysRemaining } = useSubscription();
  const { t } = useLanguage();

  if (isFree) {
    return (
      <div
        className="relative w-full overflow-hidden border-b border-primary-200 bg-gradient-to-r from-primary-50 via-primary-50/70 to-primary-100/60"
        data-test-id="subscription-banner-free"
      >
        <div className="pointer-events-none absolute -top-10 -right-10 h-32 w-32 rounded-full bg-primary-300/30 blur-3xl" />
        <div className="relative flex items-center justify-between gap-4 px-4 py-2.5 text-sm">
          <div className="flex items-center gap-2.5 min-w-0">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-500 text-white shadow-sm shadow-primary-500/30">
              <Sparkles className="h-3.5 w-3.5" />
            </span>
            <span className="truncate text-primary-900 font-medium">
              {t('subscription.banner.free')}
            </span>
          </div>
          <Link
            to="/settings/subscription"
            className="group inline-flex shrink-0 items-center gap-1 rounded-md bg-primary-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-primary-700 transition-colors"
          >
            {t('subscription.banner.cta_claim')}
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </div>
    );
  }

  if (isPaid && daysRemaining !== null && daysRemaining <= 7) {
    return (
      <div
        className="relative w-full overflow-hidden border-b border-amber-200 bg-gradient-to-r from-amber-50 via-amber-50/70 to-amber-100/60"
        data-test-id="subscription-banner-warning"
      >
        <div className="pointer-events-none absolute -top-10 -right-10 h-32 w-32 rounded-full bg-amber-300/30 blur-3xl" />
        <div className="relative flex items-center justify-between gap-4 px-4 py-2.5 text-sm">
          <div className="flex items-center gap-2.5 min-w-0">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-amber-500 text-white shadow-sm shadow-amber-500/30">
              <AlertTriangle className="h-3.5 w-3.5" />
            </span>
            <span className="truncate text-amber-900 font-medium">
              {t('subscription.banner.warning', { days: daysRemaining })}
            </span>
          </div>
          <Link
            to="/settings/subscription"
            className="group inline-flex shrink-0 items-center gap-1 rounded-md bg-amber-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-amber-700 transition-colors"
          >
            {t('subscription.banner.cta_renew')}
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </div>
    );
  }

  return null;
}
